import { ZoomProps } from '@cast/design-system';

import { useReactRouterStrategy } from './useReactRouterStrategy';

import { DASHBOARD_CHART_ZOOM_QUERY_PARAM_KEYS } from '../constants/dashboardCharts';

const useDashboardChartZoomState = useReactRouterStrategy.bind(null, {
  queryParamsKeys: DASHBOARD_CHART_ZOOM_QUERY_PARAM_KEYS,
});

export const dashboardChartZoomProps: Pick<
  ZoomProps,
  'xAxisDataKey' | 'useZoomState'
> = {
  xAxisDataKey: 'chartTimestampUnix',
  useZoomState: useDashboardChartZoomState,
};
